import $ from 'jquery';

import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/css/style.scss';

$(() => {
  $('.menu-toggle').on('click', () => {
    $('.menu-toggle').toggleClass('open');
    $('.mobile-nav').slideToggle();
  });

  $('.page-template-homepage .featured-deals-slider .slider').bxSlider({
    slideWidth: 360,
    minSlides: 1,
    maxSlides: 10,
    moveSlides: 1,
    slideMargin: 40,
    touchEnabled: false,
    prevSelector: '.page-template-homepage .featured-deals-slider .controls .prev',
    nextSelector: '.page-template-homepage .featured-deals-slider .controls .next',
    prevText: '<i class="fa-solid fa-chevron-left"></i>',
    nextText: '<i class="fa-solid fa-chevron-right"></i>'
  });

  $('.page-template-homepage .brands-slider .slider').bxSlider({
    slideWidth: 150,
    minSlides: 2,
    maxSlides: 20,
    moveSlides: 2,
    slideMargin: 28,
    adaptiveHeight: true,
    prevSelector: '.page-template-homepage .brands-slider .controls .prev',
    nextSelector: '.page-template-homepage .brands-slider .controls .next',
    prevText: '<i class="fa-solid fa-chevron-left"></i>',
    nextText: '<i class="fa-solid fa-chevron-right"></i>'
  });

  const ticketsSliderDesktop = {
    slideWidth: 580,
    minSlides: 1,
    maxSlides: 10,
    moveSlides: 1,
    slideMargin: 0,
    pager: false,
    touchEnabled: false,
    prevSelector: '.page-template-homepage .ticket-slider .controls .prev',
    nextSelector: '.page-template-homepage .ticket-slider .controls .next',
    prevText: '<i class="fa-solid fa-chevron-left"></i>',
    nextText: '<i class="fa-solid fa-chevron-right"></i>'
  };

  const ticketsSliderMobile = {
    slideWidth: 345,
    minSlides: 1,
    maxSlides: 2,
    moveSlides: 1,
    slideMargin: 0,
    pager: false,
    prevSelector: '.page-template-homepage .ticket-slider .controls .prev',
    nextSelector: '.page-template-homepage .ticket-slider .controls .next',
    prevText: '<i class="fa-solid fa-chevron-left"></i>',
    nextText: '<i class="fa-solid fa-chevron-right"></i>'
  };

  const ticketSlider = $('.page-template-homepage .ticket-slider .slider').bxSlider(ticketsSliderDesktop);

  let postSlider;
  const postSlideConfig = {
    slideWidth: 330,
    minSlides: 1,
    maxSlides: 3,
    moveSlides: 1,
    controls: false
  };

  function onScreenResized() {
    const screenWidth = $(window).width();

    if (ticketSlider.length > 0) {
      if (screenWidth <= 615) {
        ticketSlider.reloadSlider(ticketsSliderMobile);
      }
      else {
        ticketSlider.reloadSlider(ticketsSliderDesktop);
      }
    }

    if ($('.page-template-homepage .member-updates .posts').length > 0) {
      if (screenWidth <= 767) {
        if (!postSlider) {
          postSlider = $('.page-template-homepage .member-updates .posts').bxSlider(postSlideConfig);
        }
      }
      else if (postSlider) {
        postSlider.destroySlider();
      }
    }
  }

  onScreenResized();

  $(window).on('resize', onScreenResized);

  let resizeTimeout;
  $(window).on('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(onScreenResized, 200);
  });

  $('.page-template-homepage .featured-deals .slider').bxSlider({
    slideWidth: 275,
    minSlides: 1,
    maxSlides: 10,
    moveSlides: 1,
    slideMargin: 20,
    pager: false,
    touchEnabled: false,
    prevSelector: '.page-template-homepage .featured-deals .controls .prev',
    nextSelector: '.page-template-homepage .featured-deals .controls .next',
    prevText: '<i class="fa-solid fa-chevron-left"></i>',
    nextText: '<i class="fa-solid fa-chevron-right"></i>'
  });

  $(document).on('click', '.category', (e) => {
    const questions = $(e.currentTarget).next('.questions');
    const category = $(e.currentTarget);
    $('.questions').not(questions).slideUp();
    $('.category').not(category).removeClass('open');
    questions.slideToggle();
    category.toggleClass('open');
    $('.answer').slideUp();
    $('question').removeClass('open');
  });

  $(document).on('click', '.question', (e) => {
    const answer = $(e.currentTarget).next('.answer');
    const question = $(e.currentTarget);
    $('.answer').not(answer).slideUp();
    $('.question').not(question).removeClass('open');
    answer.slideToggle();
    question.toggleClass('open');
  });

  function signupModalOpen() {
    $('.modal.signup').css('display', 'flex').hide().fadeIn();
  }

  function signinModalOpen() {
    $('.modal.signin').css('display', 'flex').hide().fadeIn();
  }

  function passwordModalOpen() {
    $('.modal.password').css('display', 'flex').hide().fadeIn();
  }

  $(document).on('click', 'a[href="#sign-in"]', (e) => {
    e.preventDefault();
    $('.modal').fadeOut();
    signinModalOpen();
  });

  $(document).on('click', 'a[href="#sign-up"]', (e) => {
    e.preventDefault();
    $('.modal').fadeOut();
    signupModalOpen();
  });

  $(document).on('click', 'a[href="#forgot-password"]', (e) => {
    e.preventDefault();
    $('.modal').fadeOut();
    passwordModalOpen();
  });

  $(document).on('click', '.modal .popup .close', (e) => {
    $('.modal').fadeOut();
  });

  $(document).on('click', '.modal.redeem .popup .close', (e) => {
    $('.modal.redeem .description').slideUp();
    $('.modal.redeem .offers').slideUp();
  });

  $('#registration').on('submit', (e) => {
    e.preventDefault();

    // Clear previous errors
    $('.modal.signup .error').slideUp();
    $('.modal.signup .error').text('');

    // Array to store error messages
    const errors = [];

    // Check the email format
    const email = $('.modal.signup #email').val();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      errors.push('Enter a valid email.');
    }

    // Check the password length
    const password = $('.modal.signup #signup_password').val();
    if (password.length < 8) {
      errors.push('Your password must be at least 8 characters.');
    }

    if (errors.length > 0) {
      $('.modal.signup .error').html(errors.join('<br />'));
      $('.modal.signup .error').slideDown();
    }
    else {
      // Ajax call to create the user account
      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'create_wordpress_account',
          name: $('#name').val(),
          email: $('#email').val(),
          password: $('#signup_password').val(),
          member_number: $('#member-number').val()
        },
        success(response) {
          const responseData = JSON.parse(response);
          if (responseData.error) {
            errors.push(`Error: ${responseData.error}`);
            $('.modal.signup .error').html(errors.join('<br />'));
            $('.modal.signup .error').slideDown();
          }
          else {
            // Set login state
            ajax.isLogged = 1;

            // Hide modal
            $('.modal').fadeOut();
            $('body').css('overflow', '');

            // Change sign in to account settings
            $('header #sign-in').attr('href', '/account-settings');
            $('header #sign-in span').text('Account');

            // Add dropdown
            if ($('#sign-out').length === 0) {
              $('div.secondary-nav').append(`<div class="dropdown">
                <a href="/account-settings" id="account-settings">Account Settings</a>
                <a href="#" id="sign-out">Log Out</a>
              </div>`);

              $('#sign-out').on('click', (e) => {
                e.preventDefault();
                $.post(
                  ajaxurl,
                  { action: 'custom_logout' },
                  (response) => {
                    window.location.href = '/';
                  }
                );
              });
            }
          }
        },
        error(errorThrown) {
          errors.push(`Fatal Error: ${JSON.stringify(errorThrown)}`);
          $('.modal.signup .error').html(errors.join('<br />'));
          $('.modal.signup .error').slideDown();
        }
      });
    }
  });

  $('#login-form').on('submit', (e) => {
    e.preventDefault();

    // Clear previous errors
    $('.modal.signin .error').slideUp();
    $('.modal.signin .error').text('');

    // Array to store error messages
    const errors = [];

    // Check the email format
    const email = $('.modal.signin #username').val();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      errors.push('Enter a valid email.');
    }
    const password = $('.modal.signin #signin_password').val();

    if (errors.length > 0) {
      $('.modal.signin .error').html(errors.join('<br />'));
      $('.modal.signin .error').slideDown();
    }
    else {
      // Ajax call to authenticate the user
      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'authenticate_wordpress_user',
          log: email,
          pwd: password
        },
        success(response) {
          const responseData = JSON.parse(response);
          if (responseData.error) {
            errors.push(`Error: ${responseData.error}`);
            $('.modal.signin .error').html(errors.join('<br />'));
            $('.modal.signin .error').slideDown();
          }
          else {
            // Set login state
            ajax.isLogged = 1;

            // Hide the login modal
            $('.modal').fadeOut();
            $('body').css('overflow', '');

            // Update the sign-in link to become an account settings link
            $('header #sign-in').attr('href', '/account-settings');
            $('header #sign-in span').text('Account');

            // Hide the join button
            $('header #join-now').hide();

            // Add the Log Out link
            if ($('#sign-out').length === 0) {
              $('div.secondary-nav').append(`<div class="dropdown">
                <a href="/account-settings" id="account-settings">Account Settings</a>
                <a href="#" id="sign-out">Log Out</a>
              </div>`);

              $('#sign-out').on('click', (e) => {
                e.preventDefault();
                $.post(
                  ajaxurl,
                  { action: 'custom_logout' },
                  (response) => {
                    window.location.href = '/';
                  }
                );
              });
            }
          }
        },
        error(errorThrown) {
          errors.push(`Fatal Error: ${JSON.stringify(errorThrown)}`);
          $('.modal.signin .error').html(errors.join('<br />'));
          $('.modal.signin .error').slideDown();
        }
      });
    }
  });

  const price = [];
  price.lunch = 208;
  price.dinner = 312;
  price.pizza = 364;
  price.games = 48;
  price.tickets = 48;
  price.rentals = 12;
  price.hotel = 40;
  price.car = 10;
  price.golf = 15;
  price.cruise = 22;
  price.park = 22;
  price.theater = 20;
  price.oil = 11;
  price.carpets = 49;
  price.flowers = 7;
  price.ski = 17;

  let savings = 0;

  function updateSavings() {
    const pig0 = '/wp-content/uploads/2023/08/pig-0.png';
    const pig1 = '/wp-content/uploads/2023/08/pig-100-2k.png';
    const pig2 = '/wp-content/uploads/2023/08/pig-2k-4k.png';
    const pig3 = '/wp-content/uploads/2023/08/pig-4k.png';

    savings = ($('#lunch').val() * price.lunch)
      + ($('#dinner').val() * price.dinner)
      + ($('#pizza').val() * price.pizza)
      + ($('#games').val() * price.games)
      + ($('#tickets').val() * price.tickets)
      + ($('#rentals').val() * price.rentals)
      + ($('#hotel').val() * price.hotel)
      + ($('#car').val() * price.car)
      + ($('#golf').val() * price.golf)
      + ($('#cruise').val() * price.cruise)
      + ($('#park').val() * price.park)
      + ($('#theater').val() * price.theater)
      + ($('#oil').val() * price.oil)
      + ($('#carpets').val() * price.carpets)
      + ($('#flowers').val() * price.flowers)
      + ($('#ski').val() * price.ski);

    $('#savings span').text(savings);

    if (savings <= 99) {
      $('#pig').attr('src', pig0);
    }
    else if (savings <= 2000) {
      $('#pig').attr('src', pig1);
    }
    else if (savings <= 4000) {
      $('#pig').attr('src', pig2);
    }
    else if (savings > 4000) {
      $('#pig').attr('src', pig3);
    }
  }

  $('.savings-calculator input').on('change', updateSavings);

  function updateButtonState(input) {
    const minusButton = input.siblings('.minus');
    const value = parseInt(input.val());
    if (value <= 0) {
      minusButton.prop('disabled', true);
    }
    else {
      minusButton.prop('disabled', false);
    }
  }

  $('.savings-calculator .minus').on('click', (e) => {
    const input = $(e.currentTarget).siblings('input');
    const value = parseInt(input.val()) - 1;
    input.val(value < 0 ? 0 : value);
    updateButtonState(input);
    updateSavings();
  });

  $('.savings-calculator .plus').on('click', (e) => {
    const input = $(e.currentTarget).siblings('input');
    const value = parseInt(input.val()) + 1;
    input.val(value);
    updateButtonState(input);
    updateSavings();
  });

  $('.savings-calculator input[type="number"]').on('keydown', (e) => {
    // Allow: backspace, delete, tab, escape, enter and numbers
    const allowedKeys = [46, 8, 9, 27, 13, 110, 190];
    if ($.inArray(e.code, allowedKeys) !== -1
      // Allow: Ctrl+A
      || (e.code === 65 && e.ctrlKey === true)
      // Allow: home, end, left, right
      || (e.code >= 35 && e.keyCcodeode <= 39)) {
      // Let it happen, don't do anything
      return;
    }

    // Ensure that it's a number and stop the keypress if not
    if ((e.shiftKey || (e.code < 48 || e.code > 57)) && (e.code < 96 || e.code > 105)) {
      e.preventDefault();
    }
  }).on('blur', (e) => {
    const input = $(e.currentTarget);
    if (input.val() === '') {
      input.val('0');
    }
    updateButtonState(input);
  }).each(() => {
    updateButtonState($(this));
  });

  const savingsElement = $('.savings');

  if (savingsElement.length) {
    const container = savingsElement.parent();
    let originalOffset = savingsElement.offset().top;
    let originalHeight = savingsElement.outerHeight() + 20;

    const updateSizes = () => {
      originalOffset = savingsElement.offset().top;
      originalHeight = savingsElement.outerHeight() + 20;
      // Update the width when resizing the window
      if (savingsElement.hasClass('sticky')) {
        savingsElement.css('width', `${container.width() - 50}px`);
      }
    };

    $(window).on('resize', updateSizes);

    $(window).on('scroll', () => {
      if ($(window).scrollTop() > originalOffset) {
        container.css('height', `${originalHeight}px`);
        savingsElement.addClass('sticky');
        savingsElement.css('width', `${container.width() - 50}px`);
      }
      else {
        savingsElement.removeClass('sticky');
        savingsElement.css('width', 'auto');
        container.css('height', 'auto');
      }
    });

    updateSizes();
  }

  $('.password-toggle').on('click', (e) => {
    const eyeIcon = $(e.target);
    const passwordField = eyeIcon.siblings('input[type="password"], input[type="text"]');

    if (passwordField.attr('type') === 'password') {
      passwordField.attr('type', 'text');
      eyeIcon.removeClass('fa-eye').addClass('fa-eye-slash');
    }
    else {
      passwordField.attr('type', 'password');
      eyeIcon.removeClass('fa-eye-slash').addClass('fa-eye');
    }
  });

  $('#sign-out').on('click', (e) => {
    e.preventDefault();
    $.post(
      ajaxurl,
      { action: 'custom_logout' },
      (response) => {
        window.location.href = '/';
      }
    );
  });

  function viewLocation(locationKey) {
    $('.modal.redeem .loading').show();
    $('.modal.redeem').css('display', 'flex').hide().fadeIn();

    $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'access_get_location',
        key: locationKey
      }
    }).then((response) => {
      const location = response.data.location.locations[0];
      const store = response.data.store;
      $('.modal.redeem .popup .logo').attr('src', location.logo_url);
      $('.modal.redeem .popup .logo').attr('alt', `${location.physical_location.location_name} logo`);
      $('.modal.redeem .popup h3 .title').html(location.physical_location.location_name);
      $('.modal.redeem .popup .store-key').html(location.location_store.store_key);
      $('.modal.redeem .popup .description').html(location.location_store.description);
      $('.modal.redeem .address').empty();

      $.each(store.locations, (index, location) => {
        const physicalLocation = location.physical_location;
        let optionAddress;

        if (!physicalLocation.online_exclusive) {
          optionAddress = `${physicalLocation.street_address}, ${physicalLocation.city_locality}, ${physicalLocation.state_region} ${physicalLocation.postal_code}`;
        }

        $('.modal.redeem .address').append(new Option(optionAddress, physicalLocation.location_key));
      });

      return getOffers(locationKey);
    }).then((offers) => {
      const ul = $('<ul></ul>');

      if (offers) {
        if (ajax.isLogged === 1) {
          offers.forEach((offer) => {
            ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><button class="btn black" data-redeemkey="${offer.offer_key}" data-redeemmethods="${offer.redemption_methods}">Redeem</button></div><div class="col links"></div></li>`);
            ul.css('padding', '0');
          });
        }
        else {
          offers.forEach((offer) => {
            ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><a class="btn black" href="#sign-in">Log In</a></div><div class="col links"></div></li>`);
            ul.css('padding', '0');
          });
        }
      }
      else {
        ul.append('No offers available at this location at this time. Please check another location.');
        ul.css('padding', '20px 60px');
      }

      $('.modal.redeem .loading').fadeOut();
      $('.modal.redeem .description').slideDown();
      $('.modal.redeem .popup .offers').html(ul).slideDown();
    }).catch((error) => {
      console.error(error);
    });
  }

  function viewStore(storeKey) {
    $('.modal.redeem .loading').show();
    $('.modal.redeem').css('display', 'flex').hide().fadeIn();

    $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'access_get_store',
        key: storeKey
      }
    }).then((response) => {
      const store = response.data.store.stores[0];
      const locations = response.data.locations.locations;

      $('.modal.redeem .popup .logo').attr('src', store.logo_url);
      $('.modal.redeem .popup .logo').attr('alt', `${store.name} logo`);
      $('.modal.redeem .popup h3 .title').html(store.name);
      $('.modal.redeem .popup .store-key').html(storeKey);
      $('.modal.redeem .popup .description').html(store.description);
      $('.modal.redeem .address').empty();

      $.each(locations, (index, location) => {
        const physicalLocation = location.physical_location;
        let optionAddress;

        if (!physicalLocation.online_exclusive) {
          optionAddress = `${physicalLocation.street_address}, ${physicalLocation.city_locality}, ${physicalLocation.state_region} ${physicalLocation.postal_code}`;
        }

        $('.modal.redeem .address').append(new Option(optionAddress, physicalLocation.location_key));
      });

      return getOffers(locations[0].physical_location.location_key);
    }).then((offers) => {
      const ul = $('<ul></ul>');

      if (ajax.isLogged === 1) {
        offers.forEach((offer) => {
          ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><button class="btn black" data-redeemkey="${offer.offer_key}" data-redeemmethods="${offer.redemption_methods}">Redeem</button></div><div class="col links"></div></li>`);
          ul.css('padding', '0');
        });
      }
      else {
        offers.forEach((offer) => {
          ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><a class="btn black" href="#sign-in">Log In</a></div><div class="col links"></div></li>`);
          ul.css('padding', '0');
        });
      }

      $('.modal.redeem .loading').fadeOut();
      $('.modal.redeem .description').slideDown();
      $('.modal.redeem .popup .offers').html(ul).slideDown();
    }).catch((error) => {
      console.error(error);
    });
  }

  $('.modal.redeem .address').on('change', (e) => {
    const newLocationKey = $(e.target).val();

    $('.modal.redeem .popup .offers').slideUp().html('');

    getOffers(newLocationKey).then((offers) => {
      const ul = $('<ul></ul>');

      if (offers) {
        if (ajax.isLogged === 1) {
          offers.forEach((offer) => {
            ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><button class="btn black" data-redeemkey="${offer.offer_key}" data-redeemmethods="${offer.redemption_methods}">Redeem</button></div><div class="col links"></div></li>`);
            ul.css('padding', '0');
          });
        }
        else {
          offers.forEach((offer) => {
            ul.append(`<li class="row"><div class="col col-sm-7"><h6>${offer.title}</h6><div class="offer-key">${offer.offer_key}</div><div class="terms">${offer.terms_of_use}</div><a href="#" class="show-terms">Offer Terms</a></div><div class="col col-sm-5"><a class="btn black" href="#sign-in">Log In</a></div><div class="col links"></div></li>`);
            ul.css('padding', '0');
          });
        }

        $('.modal.redeem .popup .offers').html(ul);
      }
      else {
        ul.append('No offers available at this location at this time. Please check another location.');
        ul.css('padding', '20px 60px');
      }

      $('.modal.redeem .popup .offers').html(ul).slideDown();
    }).catch((error) => {
      console.error(error);
    });
  });

  function getOffers(locationKey) {
    return $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'access_get_offers',
        key: locationKey
      }
    }).then((response) => response.data.offers).catch((error) => {
      console.error(error);
    });
  }

  $(document).on('click', '[data-locationkey]', (e) => {
    const locationKey = $(e.currentTarget).data('locationkey');
    viewLocation(locationKey);
  });

  $(document).on('click', '[data-storekey]', (e) => {
    const storeKey = $(e.currentTarget).data('storekey');
    viewStore(storeKey);
  });

  $(document).on('click', '[data-redeemkey]', (e) => {
    const redeemKey = $(e.currentTarget).data('redeemkey');
    const redeemMethods = $(e.currentTarget).data('redeemmethods');
    $(e.target).prop('disabled', true);

    $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'access_redeem_offer',
        key: redeemKey,
        methods: redeemMethods
      }
    }).then((response) => {
      if (response.data[0] && response.data[0].message === 'Invalid member_key') {
        const error = '<p>Please <a href="#sign-in">log in</a> to redeem deals</p>';
        $(e.target).parent().siblings('.links').html(error)
          .slideDown();
      }
      else {
        const ul = $('<ul></ul>');
        response.data.forEach((method) => {
          switch (method.redemption_method) {
            case 'instore':
              ul.append(`<li><a href="${method.details.link}" target="_blank"class="btn">View Coupon</a></li>`);
              break;
            case 'instore_print':
              ul.append(`<li><a href="${method.details.link}" target="_blank"class="btn">Print Coupon</a></li>`);
              break;
            case 'link':
              ul.append(`<li>${method.details.display}</li>`);
              break;
            case 'call':
              ul.append(`<li>${method.details.display}</li>`);
              break;
            default:
              break;
          }
        });

        $(e.target).parent().siblings('.links').html(ul)
          .slideDown();
      }

      $(e.target).slideUp();
    }).catch((error) => {
      console.error(error);
    });
  });

  let isOpen = false;
  $('.modal.redeem .more').on('click', (e) => {
    e.preventDefault();

    const fullHeight = $('.modal.redeem .description')[0].scrollHeight;

    if (!isOpen) {
      $('.modal.redeem .description').animate({
        maxHeight: fullHeight
      }, 400);

      $(e.target).text('Read Less');

      isOpen = true;
    }
    else {
      $('.modal.redeem .description').animate({
        maxHeight: '80px'
      }, 400);
      $(e.target).text('Read More');

      isOpen = false;
    }
  });

  $('.modal.redeem').on('click', '.show-terms', (e) => {
    e.preventDefault();
    $(e.target).siblings('.terms').slideToggle();
  });

  $(document).on('click', '.offer-key', (e) => {
    const text = $(e.target).text();

    navigator.clipboard.writeText(text).then(() => {
      console.log(`Copied Offer ID: ${text}`);
    }).catch(() => {
    });
  });

  $(document).on('click', '.store-key', (e) => {
    const text = $(e.target).text();

    navigator.clipboard.writeText(text).then(() => {
      console.log(`Copied Store ID: ${text}`);
    }).catch(() => {
    });
  });

  $('.contact-tab').on('click', (e) => {
    $('.tab').removeClass('active');
    $(e.target).addClass('active');
    $('.contact-form').slideDown();
    $('.cancel-form').slideUp();
  });

  $('.cancel-tab').on('click', (e) => {
    $('.tab').removeClass('active');
    $(e.target).addClass('active');
    $('.cancel-form').slideDown();
    $('.contact-form').slideUp();
  });
});
